import React from "react";
import TrackingPagePresentational from "./tracking-page-presentational";

const TrackingPageFunctional = () => {
	return <TrackingPagePresentational />
};

export default TrackingPageFunctional;
